import React, { useEffect, useState } from "react";

import { Spinner } from "react-bootstrap";
import BackButtom from "../../../../components/backButton";
import FormFactory from "../../../../components/form-factory";

import * as S from "./styles";

import { FieldsCNAES } from "./fields";
import { CNAESModel } from "../../../../../domain/models/cnae";
import { EconomicActivitiesData } from "./economic-activities";
import { CityProps, StateProps } from "../../../../../domain/models/address.model";
import { makeRemoteAddresss } from "../../../../../main/factories/usecases/address-controller/remote-address-controller-factory";
import { EconomicActivityModel } from "../../../../../domain/models/economic-activity";
import { makeRemoteEconomicActivity } from "../../../../../main/factories/usecases/activity-economic/remote-activity-economic-factory";
import { toastUtils } from "../../../../../utils";
import Icons from "../../../../components/icons-helper";

type IProps = {
  onSubmit: (values: any, ec: EconomicActivitiesData, actions: any) => Promise<void>;
  data?: CNAESModel;
  edit?: boolean;
  loading?: boolean;
  id?: string;
  handleEdit: () => void;
};

const CnaeViewEdit: React.FC<IProps> = ({
  onSubmit,
  data,
  edit,
  loading,
  id,
  handleEdit,
}) => {
  const [economicActivitiesData, setEconomicActivitiesData] = React.useState<
    EconomicActivitiesData | undefined
  >();
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);
  const [economicActivityList, setEconomicActivityList] = useState<EconomicActivityModel[]>([]);

  const loadCities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };

  useEffect(() => {
    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (!data?.id) return;
      const activityData = await makeRemoteEconomicActivity().loadByCNAE(data.id);
      setEconomicActivityList(activityData);
    })();
  }, [data?.id]);

  useEffect(() => {
    (async () => {
      if (!data?.cityPattern?.state?.id) return;
      const citiesData = await makeRemoteAddresss().loadCities(data.cityPattern.state.id);
      setCitiesList(citiesData);
    })();
  }, [data?.cityPattern?.state?.id]);

  const handleEconomicActivitiesData = (ec: EconomicActivitiesData): void => {
    setEconomicActivitiesData(ec);
  };

  const handleSubmit = async (values: any, actions: any): Promise<void> => {
    if (!economicActivitiesData?.isValid) {
      toastUtils.showMessage({
        type: "error",
        message: "Dados de atividades econômicas inválidos. Por favor, verifique os valores inseridos.",
      });
      actions.setSubmitting(false);
      return;
    }


    await onSubmit(values, economicActivitiesData, actions);
  };

  const getTitle = (): string => {
    if (edit && id) {
      return "Editar CNAE";
    }
    if (id) {
      return "Voltar";
    }
    return "Novo CNAE";
  };


  return (
    <S.Wrapper>
      <S.Header>
        <BackButtom text={getTitle()} />

        {!edit && (
          <S.EditButton onClick={handleEdit}>
            <Icons name="edit" width={20} height={20} color="#FFF" />
            <span>
              Editar
            </span>
          </S.EditButton>
        )}
      </S.Header>
      <S.CardContent>
        {!loading && (
          <FormFactory
            groups={FieldsCNAES(data, stateList, citiesList, economicActivityList, loadCities, handleEconomicActivitiesData, edit)}
            onSubmit={handleSubmit}
            button={{
              submit: "Salvar",
              submitting: "Salvando...",
              hide: !edit,
            }}
          />
        )}
        {loading && (
          <div className="d-flex justify-content-center">
            <Spinner animation="grow" variant="primary" />
          </div>
        )}
      </S.CardContent>
    </S.Wrapper>
  );
};

export default CnaeViewEdit;
